import { Talent } from "../../Classes";

const tier7 = [
  null,
  new Talent(
    "Mass Corruption",
    "spell_shadow_soulleech",
    [
      "Applies corruption to all enemies within the area, causing 436 Shadow damage over 18 sec.",
    ],
    1,
    [[]],
    null,
    null,
    "472 mana",
    "30 yd range",
    "2 sec cast",
    "30 sec cooldown",
    null,
    {
      isNew: true,
      isChanged: false,
      isMoved: false,
    },
  ),
  null,
  null,
];

export default tier7;
